// Prime One Sports — theme.js
document.addEventListener('DOMContentLoaded', function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  // Small toast notification, e.g. "X added to cart" or newsletter confirmation
  function showToast(message) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('data-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3600);
  }

  // Newsletter signup success popup (footer form reloads the page on submit;
  // the section renders a hidden marker element when Shopify confirms the
  // customer form posted successfully).
  var newsletterFlag = document.querySelector('[data-newsletter-success="true"]');
  if (newsletterFlag) {
    showToast("You've been added to our mailing list — look out for specials and upcoming signings!");
  }

  // Keep the hidden variant-id input in sync with the option selects, so
  // Add to Cart submits whichever variant the shopper actually picked
  // instead of always the first available one.
  var productForms = document.querySelectorAll('[data-product-form]');
  productForms.forEach(function (form) {
    var variantsScript = form.querySelector('[data-product-variants]');
    var idInput = form.querySelector('[data-variant-id]');
    var addBtn = form.querySelector('[data-add-to-cart-btn]');
    if (!variantsScript || !idInput) return;

    var variants;
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (err) {
      return;
    }

    var selects = Array.prototype.slice.call(form.querySelectorAll('[data-option-selector]'));
    if (!selects.length) return;

    function updateVariant() {
      var selectedValues = selects.map(function (select) { return select.value; });
      var match = variants.find(function (variant) {
        return selectedValues.every(function (value, index) {
          return variant['option' + (index + 1)] === value;
        });
      });

      if (match) {
        idInput.value = match.id;
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
      } else if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', updateVariant);
    });
    updateVariant();
  });

  // Add to cart (AJAX) for product form
  var forms = document.querySelectorAll('[data-product-form]');
  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('[data-add-to-cart-btn]');
      if (submitBtn && submitBtn.disabled) return;
      var formData = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (result) {
          if (result && result.status) {
            console.error('Add to cart failed:', result.description || result.message);
            alert(result.description || 'Could not add this item to your cart.');
            return null;
          }
          showToast((result && result.product_title ? result.product_title : 'Item') + ' added to cart');
          return fetch('/cart.js');
        })
        .then(function (res) { return res ? res.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          var countEl = document.querySelector('[data-cart-count]');
          if (countEl) countEl.textContent = cart.item_count;
        })
        .catch(function (err) { console.error('Cart error:', err); });
    });
  });
});
